/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M12 2L12 22M2 12H22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="20"
				rx="4"
				fill="currentColor"
			/>
			<path
				d="M12 2L12 22M2 12H22M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M11.25 2.85C11.25 2.28995 11.25 2.00992 11.141 1.79601C11.0451 1.60785 10.8922 1.45487 10.704 1.35899C10.4901 1.25 10.2101 1.25 9.65 1.25H9.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V9.65C1.25 10.2101 1.25 10.4901 1.35899 10.704C1.45487 10.8922 1.60785 11.0451 1.79601 11.141C2.00992 11.25 2.28995 11.25 2.85 11.25H9.65C10.2101 11.25 10.4901 11.25 10.704 11.141C10.8922 11.0451 11.0451 10.8922 11.141 10.704C11.25 10.4901 11.25 10.2101 11.25 9.65V2.85Z"
				fill="currentColor"
			/>
			<path
				d="M2.85 12.75C2.28995 12.75 2.00992 12.75 1.79601 12.859C1.60785 12.9549 1.45487 13.1078 1.35899 13.296C1.25 13.5099 1.25 13.7899 1.25 14.35V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H9.65C10.2101 22.75 10.4901 22.75 10.704 22.641C10.8922 22.5451 11.0451 22.3922 11.141 22.204C11.25 21.9901 11.25 21.7101 11.25 21.15V14.35C11.25 13.7899 11.25 13.5099 11.141 13.296C11.0451 13.1078 10.8922 12.9549 10.704 12.859C10.4901 12.75 10.2101 12.75 9.65 12.75H2.85Z"
				fill="currentColor"
			/>
			<path
				d="M12.75 21.15C12.75 21.7101 12.75 21.9901 12.859 22.204C12.9549 22.3922 13.1078 22.5451 13.296 22.641C13.5099 22.75 13.7899 22.75 14.35 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V14.35C22.75 13.7899 22.75 13.5099 22.641 13.296C22.5451 13.1078 22.3922 12.9549 22.204 12.859C21.9901 12.75 21.7101 12.75 21.15 12.75H14.35C13.7899 12.75 13.5099 12.75 13.296 12.859C13.1078 12.9549 12.9549 13.1078 12.859 13.296C12.75 13.5099 12.75 13.7899 12.75 14.35V21.15Z"
				fill="currentColor"
			/>
			<path
				d="M21.15 11.25C21.7101 11.25 21.9901 11.25 22.204 11.141C22.3922 11.0451 22.5451 10.8922 22.641 10.704C22.75 10.4901 22.75 10.2101 22.75 9.65V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H14.35C13.7899 1.25 13.5099 1.25 13.296 1.35899C13.1078 1.45487 12.9549 1.60785 12.859 1.79601C12.75 2.00992 12.75 2.28995 12.75 2.85V9.65C12.75 10.2101 12.75 10.4901 12.859 10.704C12.9549 10.8922 13.1078 11.0451 13.296 11.141C13.5099 11.25 13.7899 11.25 14.35 11.25H21.15Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M22 8V7.5V7.5C22 7.0357 22 6.80355 21.9846 6.6077C21.7916 4.15582 19.8442 2.20838 17.3923 2.01541C17.1965 2 16.9643 2 16.5 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V12H8M2 16V16.5V16.5C2 16.9643 2 17.1965 2.01541 17.3923C2.20838 19.8442 4.15582 21.7916 6.6077 21.9846C6.80355 22 7.0357 22 7.5 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V12H12M12 2L12 22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M12 2L12 22M2 12H22M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<g opacity="0.32">
				<path
					d="M2.85 12.75C2.28995 12.75 2.00992 12.75 1.79601 12.859C1.60785 12.9549 1.45487 13.1078 1.35899 13.296C1.25 13.5099 1.25 13.7899 1.25 14.35V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H9.65C10.2101 22.75 10.4901 22.75 10.704 22.641C10.8922 22.5451 11.0451 22.3922 11.141 22.204C11.25 21.9901 11.25 21.7101 11.25 21.15V14.35C11.25 13.7899 11.25 13.5099 11.141 13.296C11.0451 13.1078 10.8922 12.9549 10.704 12.859C10.4901 12.75 10.2101 12.75 9.65 12.75H2.85Z"
					fill="currentColor"
				/>
				<path
					d="M21.15 11.25C21.7101 11.25 21.9901 11.25 22.204 11.141C22.3922 11.0451 22.5451 10.8922 22.641 10.704C22.75 10.4901 22.75 10.2101 22.75 9.65V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H14.35C13.7899 1.25 13.5099 1.25 13.296 1.35899C13.1078 1.45487 12.9549 1.60785 12.859 1.79601C12.75 2.00992 12.75 2.28995 12.75 2.85V9.65C12.75 10.2101 12.75 10.4901 12.859 10.704C12.9549 10.8922 13.1078 11.0451 13.296 11.141C13.5099 11.25 13.7899 11.25 14.35 11.25H21.15Z"
					fill="currentColor"
				/>
			</g>
			<path
				d="M11.25 2.85C11.25 2.28995 11.25 2.00992 11.141 1.79601C11.0451 1.60785 10.8922 1.45487 10.704 1.35899C10.4901 1.25 10.2101 1.25 9.65 1.25H9.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V9.65C1.25 10.2101 1.25 10.4901 1.35899 10.704C1.45487 10.8922 1.60785 11.0451 1.79601 11.141C2.00992 11.25 2.28995 11.25 2.85 11.25H9.65C10.2101 11.25 10.4901 11.25 10.704 11.141C10.8922 11.0451 11.0451 10.8922 11.141 10.704C11.25 10.4901 11.25 10.2101 11.25 9.65V2.85Z"
				fill="currentColor"
			/>
			<path
				d="M12.75 21.15C12.75 21.7101 12.75 21.9901 12.859 22.204C12.9549 22.3922 13.1078 22.5451 13.296 22.641C13.5099 22.75 13.7899 22.75 14.35 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V14.35C22.75 13.7899 22.75 13.5099 22.641 13.296C22.5451 13.1078 22.3922 12.9549 22.204 12.859C21.9901 12.75 21.7101 12.75 21.15 12.75H14.35C13.7899 12.75 13.5099 12.75 13.296 12.859C13.1078 12.9549 12.9549 13.1078 12.859 13.296C12.75 13.5099 12.75 13.7899 12.75 14.35V21.15Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
